import type { RenderSupportingRecords } from '../../../insightRenderShapes'
import { Note } from '../InsightsBlocks'
import { InsightEntityNames } from './InsightEntityNames'

/** Reusable saved evidence display. The question owner supplies membership, labels and explanations. */
export function InsightSupportingRecords({ evidence }: { evidence?: RenderSupportingRecords }) {
  if (!evidence) return null
  return (
    <s-stack gap="small">
      <s-text fontWeight="semibold">{evidence.title}</s-text>
      <Note>{evidence.description}</Note>
      {evidence.records.map((record) => (
        <s-grid key={record.entity.id} gridTemplateColumns="minmax(0, 1fr) auto" gap="small">
          <InsightEntityNames entities={[record.entity]} separator="" />
          <s-text>{record.description}</s-text>
        </s-grid>
      ))}
    </s-stack>
  )
}
